const RESOURCE_NAME = "entities/teacherReviews";

export default {};
